import { Input } from "@/components";

import SettingsTab from "../Tab";

const renderContent = ({ model, changeFormState, FormControl }) => (
    <div>
        <div className="row">
            <FormControl className="col-sm-4" name="width" required>
                <Input
                    label="Space Width (feet)"
                    value={model.width}
                    onChange={(value) =>
                        changeFormState({
                            width: value,
                        })
                    }
                    required
                    min={0}
                    decimalDigits={2}
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-4" name="height" required>
                <Input
                    label="Space Length (feet)"
                    value={model.height}
                    onChange={(value) =>
                        changeFormState({
                            height: value,
                        })
                    }
                    required
                    min={0}
                    decimalDigits={2}
                    type="number"
                />
            </FormControl>
        </div>
        <div className="row">
            <FormControl className="col-sm-4" name="offSetX">
                <Input
                    label="X Offset (feet)"
                    value={model.offSetX}
                    decimalDigits={2}
                    onChange={(value) =>
                        changeFormState({
                            offSetX: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-4" name="offSetY">
                <Input
                    label="Y Offset (feet)"
                    value={model.offSetY}
                    decimalDigits={2}
                    onChange={(value) =>
                        changeFormState({
                            offSetY: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-4" name="offSetAngle">
                <Input
                    label="Angle Offset (degrees)"
                    value={model.offSetAngle}
                    onChange={(value) =>
                        changeFormState({
                            offSetAngle: value,
                        })
                    }
                    type="number"
                />
            </FormControl>
        </div>
    </div>
);

/**
 * Settings tab for configuring floor space dimensions and offsets.
 *
 * @param props - The settings tab props including model and form state.
 * @returns The rendered space settings tab.
 */
const SpaceTab = (props) => (
    <SettingsTab {...props} renderContent={renderContent} />
);

export default SpaceTab;
